module.exports = __webpack_public_path__ + "static/DarksideDetective0-92dcad2de95bf0f1a0ee4985cf54d8a3.png";